module.exports = __webpack_public_path__ + "static/media/refresh_dark.266fbb68.svg";